import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PatientRegistrationApi } from '../api/patient-registration.api';
import { switchMap, map } from 'rxjs/operators';

import { PatientRegistrationData, PatientRegistration } from '../../../interfaces/patient-services/patient-registration';

@Injectable()
export class PatientRegistrationMstService extends PatientRegistrationData {

    constructor(private api: PatientRegistrationApi) {
      super();
    }

    getPhyList(url: string): Observable<any> {
      return this.api.phylist(url);
    }
    getEmpList(url: string): Observable<any> {
      return this.api.emplist(url);
    }
    getLabList(url: string): Observable<any> {
      return this.api.lablist(url);
    }
    getOtherList(url: string): Observable<any> {
      return this.api.otherlist(url);
    }
    searchList(url: string,data:any): Observable<any> {
      return this.api.searchList(url,data);
    }
  
  
    list(url: string): Observable<any> {
      return this.api.list(url);
    }
    sendMessageOtp(url: string,data: any): Observable<any> {
      return this.api.sendMessageOtp(url,data);
    }

    sendMessageOtp1(url: string): Observable<any> {
      return this.api.sendMessageOtp1(url);
    }

    verifyOtp(url: string, data: any): Observable<any> {
      return this.api.verifyOtp(url, data);
    }


    sendMessage(url: string,data: any): Observable<any> {
      return this.api.sendMessage(url,data);
    }
    getCommData(url:string): Observable<any>{
      return this.api.get(url);
  }
  
    getById(url:string): Observable<PatientRegistration>{
        return this.api.getById(url);
    }
  
    create(url: string, data:PatientRegistration): Observable<PatientRegistration[]> {
      return this.api.add(url,data);
    }
  
    update(url: string, data:PatientRegistration): Observable<PatientRegistration> {
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }

    //SendMsg
    sendgreetingsMessage(url: string,data: any): Observable<any> {
      return this.api.sendgreetingsMessage(url,data);
    }
    send_email(url: string, data:any): Observable<any> {
      return this.api.send_emaild(url,data);
    }
    

    getReason(url: string): Observable<any> {
      return this.api.getReason(url);
    }
  }
  